import { Clock, LockKey, RocketLaunch } from "@phosphor-icons/react";

export const SectionSecond = () => {
  return (
    <section className="overflow-hidden from-[#F8F8F8_60%] to-[#1658A6_60%] pb-10 lg:bg-gradient-to-r">
      <div className="content-area relative grid items-center justify-center bg-[#F8F8F8] pt-0 lg:flex lg:bg-transparent lg:py-24">
        <div className="pt-10 md:py-24 lg:m-0 lg:w-auto lg:p-0">
          <h2 className="heading-1 mb-6 text-center text-black lg:text-left">Quem somos?</h2>
          <p className="body-text-1 mb-[2.125rem] pl-10 text-start text-black sm:px-8 md:px-0 lg:text-justify">
            A Santana Cred é uma promotora de crédito. <br className="inline-block" />
            Não cobramos nenhum valor para análise crédito. <br className="inline-block" />
            Atuação sólida no mercado há mais de 16 anos. <br className="inline-block" />
            <br className="inline-block" />
            Somos correspondentes dos Bancos de maior credibilidade. <br className="inline-block" />
            Atuamos e atendemos a nível Brasil
          </p>
        </div>
        <div className="relative hidden rounded-6 bg-primaria-claro py-24 lg:left-10 lg:block lg:bg-transparent lg:py-0">
          <div className="relative mx-auto w-fit translate-x-40 lg:translate-x-[12.75rem]">
            <picture>
              <img
                width="600"
                height="557"
                src="/projeto/call-center.jpg"
                alt="Nossa historia"
                className="rounded-4 object-top duration-200 sm:translate-x-[-12.75rem] lg:ml-4"
              />
            </picture>
          </div>
        </div>
        <div className="relative mx-auto mb-24 w-fit sm:translate-x-40 lg:hidden">
          <picture>
            <img
              src="/projeto/call-center.jpg"
              alt="Nossa história"
              className="h-80 w-80 rounded-full object-cover object-right duration-200 sm:translate-x-[-10rem]"
            />
          </picture>
        </div>
      </div>
      <div className="grid grid-cols-[18.5rem] grid-rows-[10rem] items-center justify-center gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-0 lg:gap-x-2 lg:px-2">
        <span className="float-badge top-full h-32 w-full bg-black text-32 text-white shadow-lg shadow-black md:h-48">
          <LockKey size={30} className="animate-move bg-white text-black" />
          <p className="w-full text-center">Segurança</p>
        </span>
        <span className="float-badge top-full h-32 w-full bg-black text-32 text-white shadow-lg shadow-black md:h-48">
          <Clock size={30} className="text animate-move bg-white text-black" />
          <p className="w-full text-center">100% Online</p>
        </span>
        <span className="float-badge top-full h-32 w-full bg-black text-32 text-white shadow-lg shadow-black md:h-48">
          <RocketLaunch size={30} className="animate-move bg-white text-black" />
          <p className="w-full text-center">Agilidade</p>
        </span>
      </div>
    </section>
  );
};
